<template>
  <div class="course-container__gallery-container">
    <v-owl-carousel
      v-if="photos.length > 0"
      margin="30"
      :responsive="{
        0:{items:1,nav:false,dots:false},
        768:{items:2,nav:true,dots:false},
        1200:{items:2,nav:true,dots:false}
      }"
    >
      <a
        :href="photo.file_path"
        class="fancybox-img company-photo-gallery__image"
        :style="backgroundImage(photo)"
        data-fancybox="fancybox-gallery" v-for="(photo, index) in photos" :key="index"
      ></a>
    </v-owl-carousel>
  </div>
</template>

<script>
  export default {
    name: "PhotoGallery",
    props: {
      photos: {
        type: Array,
        required: true
      }
    },
    data () {
      return {}
    },
    computed: {
      calcPhotos () {
        return this.photos.slice(0, 2)
      }
    },
    methods: {
      backgroundImage(item) {
        return {
          'background-image': `url(${item.file_path})`
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/PhotoGallery.vue